import { type, getContextByPath, partial } from './assist'

function mapCacheByName(name, config){
	var computed = {}

	// [key1, key2, key3...]
	if(type(config) == "array"){
		config.forEach(k => {
			computed[k] = {
				get(){
					return this[name][k]
				},

				set(val){
					this[name][k] = val
				}
			}
		})
	}
	
	// { key: path, key: path, key: path, }
	if(type(config) == "object"){
		Object.keys(config).forEach(key => {
			let path = config[key]

			computed[key] = {
				get(){
					var {o, k, a} = getContextByPath(this[name], path)

					return o[k]
				},

				set(val){
					var {o, k, a} = getContextByPath(this[name], path)
					
					o[k] = val
				},
			}
		})
	}

	return computed
}

export const mapCache = partial(mapCacheByName, "$cache")
export const mapRootCache = partial(mapCacheByName, "$rootCache")
